import { AdPlacementsComponentTypes } from '@bingads-webui-campaign-react/ad-placement-consts';

const msnSingle169100Raw = {
  componentType: AdPlacementsComponentTypes.AdPlacementPreview,
  aspectRatio: 1.69,
  type: 'Image169x100',
  associationType: 'ImageMedia169X100',
  imagePreviewHeight: 368,
  minimumRequirements: 0,
  minSize: [622, 368],
  localizedText: {
    previewTypeStringKey: _TL_('MSN carousel'),
    stringKey: _TL_('1.69 : 1'),
    disclaimerMessage: _TL_('This is an example of how your ad could appear on other websites on the Microsoft Advertising Network. The final ad format is likely to change to match the look and feel of the website.'),
  },
  previewSettings: {
    showAdsLabelWithBusinessName: true,
    showBusinessName: true,
    showImage: true,
    showLongHeadline: true,
    showGradient: true,
    showMultipleLineLongHeadline: true,
  },
  styleOverrides: {
    businessNameWithAds: {
      '& .business-name': {
        fontSize: 11,
        lineHeight: '1.364',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
      '& .adslabel': {
        fontSize: 10,
        lineHeight: '1.364',
        margin: '0 5px 0 0',
        background: 'transparent',
        borderRadius: 4,
        color: '#fff',
        fontFamily: '"Segoe UI","Segoe WP",Arial,Sans-Serif',
        fontWeight: 400,
        padding: '.8px 4px',
        border: '.5px solid hsla(0,0%,100%,.3)',
        opacity: 0.7,
      },
    },
    longHeadline: {
      color: 'white',
      height: 80,
      width: 575,
      fontSize: 28,
      lineHeight: 1.214,
    },
    previewContent: {
      width: 622,
      height: 368,
    },
    textContainer: {
      position: 'absolute',
      color: '#bebebe',
      bottom: 25,
      left: 20,
      fontSize: 10,
      lineHeight: '16px',
    },
    gradient: {
      '&:after': {
        display: 'block',
        position: 'relative',
        backgroundImage: 'linear-gradient(to bottom, transparent 0, black 100%)',
        marginTop: -250,
        height: 280,
        width: '100%',
        content: '\'\'',
      },
    },
  },
};

export default msnSingle169100Raw;
